import React from 'react'
import Row from '@amzn/meridian/row'
import Text from '@amzn/meridian/text'
import Link from '@amzn/meridian/link'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { getLegalLinkUrl, getNativeBridge, LegalLink, requestLegalLinkFromApp } from '@utils/legalLinks'

interface ILegalLinksProps {
    /** ISO country of the selected store; undefined until one is selected. */
    countryCode?: string
}

const LABEL_KEY_BY_LINK: Readonly<Record<LegalLink, string>> = {
    conditionsOfUse: 'jsma-web-profile-conditionsOfUse',
    privacyNotice: 'jsma-web-profile-privacyNotice',
}

/** "Conditions of Use | Privacy Notice": a new-tab link in a browser, an href-less request in the app. */
export const LegalLinks: React.FC<ILegalLinksProps> = ({ countryCode }) => {
    const [bundle] = useBundle(BUNDLE_NAME)
    const bridge = getNativeBridge()

    const renderLink = (link: LegalLink) => {
        const target = bridge
            ? { onClick: () => requestLegalLinkFromApp(bridge, link, countryCode) }
            : { href: getLegalLinkUrl(link, countryCode), target: '_blank', rel: 'noopener noreferrer' }
        return (
            <Link type="secondary" {...target} data-testid={`profile-legal-${link}`}>
                {/* Styled like the role label (b200, secondary) per the design, not as blue links. */}
                <Text type="b200" color="secondary">{t(bundle, LABEL_KEY_BY_LINK[link])}</Text>
            </Link>
        )
    }

    return (
        <Row alignmentHorizontal="center" spacing="200" data-testid="profile-legal-links">
            {renderLink('conditionsOfUse')}
            <Text type="b200" color="secondary" aria-hidden="true">|</Text>
            {renderLink('privacyNotice')}
        </Row>
    )
}
